'use strict';

import _ from 'lodash';
import React from 'react';
import Listing from '../common/listing';
import Partner from '../common/partner';
import Analytics from '../common/analytics';


class Partners extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    let levels = _(this.props.conference.current.partners)
      .map((partner) => { return <Partner key={partner._id} partner={partner} showLevel={true} showPhoto={true} {...this.props} /> })
      .groupBy('props.partner.partner_level')
      .value();

    let partner = this.props.conference.current.partners ?
      this.props.conference.current.partners[this.props.params.partner_id] :
      null;

    return <div className="sponsors">
      <section className="section">
        <div className="opportunities wrap-two clearfix">
          <div className="title">Partners</div>
          {!partner ? null : <Partner key={partner._id} partner={partner} showPhoto={true} showBio={true} {...this.props} />}
        </div>
      </section>
      {_.map(levels, (level, k) => {
        k = k == 'partner' ? 'Partners' : k.replace('-', ' ');
        return <section key={k} className="section">
          <Listing elements={level} title={k + ' Partners'} />
        </section>
      })}
      <Analytics view="partners" {...this.props} />
    </div>
  }
}

export default Partners;
